import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TreeItemLookup } from "@progress/kendo-angular-treeview";
import { CommonService } from "app/reusable/common.service";
import { CedNotificationService } from "ced-ng-library";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { environment } from "environments/environment";

@Component({
  selector: "app-case-details-list",
  templateUrl: "./case-details-list.component.html",
  styleUrls: ["./case-details-list.component.scss"],
})
export class CaseDetailsListComponent implements OnInit, OnDestroy {
  @Input() id;
  @Input() labelForm: FormGroup;
  @Input() labels = [];
  @Output() changeCdId = new EventEmitter();
  public serverUrlSlot3 : string = environment.Services.AlphaURLSlot2;
  @Output() changeLabels = new EventEmitter();
  public checkedKeys: any[] = [];
  send: any;
  public showLabels: boolean = false;
  public dataSource = [];
  cdId: string;
  caseDetail;
  indexGeneral: number;
  generalId: string;
  private _subject$: Subject<boolean> = new Subject();

  constructor(private commonService: CommonService, private cedNotificationService: CedNotificationService) { }
  ngOnInit() {
    this.getCaseDetails();
    if (this.id != undefined) {
      this.changeLabels.emit(this.labelForm);
      this.getCaseDetailbyId();
    }
  }

  public getCaseDetails() {
    let GetCaseDetailsURL = "CaseDetail/GetAll";
    this.commonService.getData(GetCaseDetailsURL, this.serverUrlSlot3).pipe(takeUntil(this._subject$)).subscribe((data) => {
      this.dataSource = data as [];
      this.indexGeneral = this.dataSource.findIndex(
        (item) => item.cdName == "General"
      );
      let generalCD = this.dataSource.find((item) => item.cdName == "General");
      this.generalId = generalCD.cdId;
    },
    (error) => {
      this.cedNotificationService.warning("NOTIFICATIONS.GET_CASE");
    });
  }

  public getCaseDetailbyId() {
    let getCaseTypebyIdURL = `CaseType/GetById/${this.id}`;
    this.commonService.getData(getCaseTypebyIdURL, this.serverUrlSlot3).pipe(takeUntil(this._subject$)).subscribe((data: any) => {
      this.cdId = data.ctyCaseDetailId;
      let getCaseDetailbyIdUrl = `CaseDetail/GetById/${this.cdId}`;
      this.commonService
        .getData(getCaseDetailbyIdUrl, this.serverUrlSlot3)
        .pipe(takeUntil(this._subject$)).subscribe((data: any) => {
          this.caseDetail = data;
          let index = this.dataSource.findIndex(
            (cd) => cd.cdId === this.caseDetail.cdId
          );
          if (this.caseDetail.cdName == "General") {
            this.showLabels = true;
            this.changeCdId.emit({ cdId: this.cdId, isGeneral: true });
          }
          else {
            this.changeCdId.emit({ cdId: this.cdId, isGeneral: false });
          }
          this.checkedKeys.push(index.toString());
        });
    },
    (error) => {
      this.cedNotificationService.warning("NOTIFICATIONS.GET_CASE");
    });
  }

  public isItemChecked = (_: any, index: string) => {
    return this.checkedKeys.indexOf(index) > -1 ? "checked" : "none";
  };

  public handleChecking(itemLookup: TreeItemLookup): void {
    this.checkedKeys = [itemLookup.item.index];
    this.send = [itemLookup.item.dataItem.cdId];
    if (this.checkedKeys[0] == this.indexGeneral.toString()) {
      this.showLabels = true;
      this.changeCdId.emit({ cdId: this.send[0], isGeneral: true });
    } else {
      this.showLabels = false;
      this.changeCdId.emit({ cdId: this.send[0], isGeneral: false });
    }
  }

  public labelChange(labels, i) {
    if (labels[i].isSelected) {
      this.labelForm.controls[this.getLabel(i)].enable();
    } else {
      this.labelForm.controls[this.getLabel(i)].setValue("");
      this.labelForm.controls[this.getLabel(i)].disable();
    }
    this.changeLabels.emit(this.labelForm);
  }

  getLabel(i): string {
    i = i + 1;
    return "cdlLabel" + i;
  }

  public fillLabelForm(event) {
    this.changeLabels.emit(this.labelForm);
  }

  ngOnDestroy() {
    this._subject$.unsubscribe();
  }
}